import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePipelineHook } from "../../../hooks/usePipelineHook";
import { isNil } from "lodash";
import { loanPipelineSet } from "../../../redux/actions/loanPipelineActions";
import LoanSearchAutocomplete from "./LoanSearchAutocomplete";

const LoanSearchDropdown = ({ value, onChange }) => {
  const loanPipeline = useSelector((state) => state.loanPipeline);
  const { getUserPipeline } = usePipelineHook();
  const dispatch = useDispatch();

  const options = useMemo(() => {
    if (isNil(loanPipeline)) return [];
    return loanPipeline.map((l) => ({
      label: `<${l.loanNumber}> ${l.loanName}`,
      value: l.loanNumber,
    }));
  }, [loanPipeline]);

  useEffect(() => {
    if (isNil(loanPipeline)) {
      getUserPipeline({
        onSuccessFn: (data) => dispatch(loanPipelineSet(data)),
      });
    }
  }, []); // eslint-disable-line

  return (
    <LoanSearchAutocomplete
      fullWidth
      sx={{ width: "100%" }}
      placeholder="Search by name or loan number..."
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default LoanSearchDropdown;
